import { useEffect } from "react";
import { toast } from "sonner";

/**
 * Hook che mostra un toast informativo una sola volta per utente (basato su localStorage).
 * @param {string} flagKey - chiave univoca in localStorage (es. "crm_dblclick_hint_v1")
 * @param {string} message - testo del toast
 * @param {object} options - opzionale: { duration, icon } passati a sonner
 */
export function useFirstTimeHint(flagKey, message, options = {}) {
  useEffect(() => {
    if (!flagKey || !message) return;
    try {
      if (localStorage.getItem(flagKey) === "1") return;
      // Ritardo per evitare collisione con altri toast al caricamento pagina
      const t = setTimeout(() => {
        toast.info(message, { duration: 6000, ...options });
        try { localStorage.setItem(flagKey, "1"); } catch { /* noop */ }
      }, 1200);
      return () => clearTimeout(t);
    } catch {
      // localStorage non disponibile: silenziosamente skip
    }
  }, [flagKey, message, options]);
}
